import { defineStore } from "pinia"
import { useProductStore } from "./ProductStore";
import { fetchCreateSppotTradeRecordsForUserAsync, fetchGetSpotTradeRecordsListForUserAsync, OutputSpotTradeRecordsList } from "@/typescript/Services/Api/OrderApi";
import { useLocale } from "@/hooks/useLocale";
import Tools from "@/utils/Tools";

export const useTransactionStore = defineStore('transaction', {
    state: () => ({
        selectJage: 1,
        fixedPrice: "",
        tractionCount: "1",
        selectTabAction: 'buy' as 'buy' | 'sell',
        chiCangObj: {
            active: 0,
            filter: -1,
            chicangList: [],
            weituoList: []
        },
        spotTradeRecordsOpenObj: {
            page: 1,
            pageSize: 50,
            total: 0,
            list: []
        } as {
            page: number,
            pageSize: number,
            total: number,
            list: OutputSpotTradeRecordsList[]
        }
    }),
    getters: {
        jiageOptions() {
            const local = useLocale();
            return [
                {
                    label: local.t('components.TransactionCenterConsoleComponent.scjg'),
                    value: 1
                },
                {
                    label: local.t('components.TransactionCenterConsoleComponent.gdjg'),
                    value: 2
                }
            ];
        },
        jiageObj(): { selectJage: number; jiageOptions: { label: string; value: number }[] } {
            return {
                selectJage: this.selectJage,
                jiageOptions: this.jiageOptions
            }
        }
    },
    actions: {
        /**
         * 创建现货交易
         */
        CreateSppotTradeRecordsForUser() {
            const productStore = useProductStore();
            fetchCreateSppotTradeRecordsForUserAsync({
                ProductId: productStore.CurrentProductData.Id ?? 0,
                Side: this.selectTabAction,
                SideType: this.jiageObj.selectJage == 1 ? 'market_price' : 'fixed_price',
                BuyUnitPrice: +this.fixedPrice,
                LotSize: +this.tractionCount
            }).then(resp => {
                if (resp.CheckIsOk()) {
                    Tools.AlertSuccess("Order successfully placed!");
                }
            })
        },
        /**
         * 获取持仓仓位列表
         */
        GetFuturesTradeRecordsOpenListForUser() {
            /**
            * 状态
            */
            let status: "none" | "pending" | "open" | "closed" | "liquidated" = "pending";
            switch (this.chiCangObj.active) {
                case 0:
                    status = "open";
                    break;
                // case 1:
                //     status = "pending";
                //     break;
                case 1:
                    status = "closed";
                    break;
                // case 3:
                //     status = "none";
                //     break;
            }

            fetchGetSpotTradeRecordsListForUserAsync(this.spotTradeRecordsOpenObj.page, this.spotTradeRecordsOpenObj.pageSize, {
                Status: status
            }).then(resp => {
                if (resp.CheckIsOk()) {
                    const d = resp.data!;
                    this.spotTradeRecordsOpenObj.total = d.total;
                    this.spotTradeRecordsOpenObj.list = d.list;
                }
            });
        }
    }
})